var React = require('react');

function Dumpster (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M576 240v32a16 16 0 0 1-16 16h-28l-20 160v16a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-16H128v16a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16v-16L44 288H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h20l-4-32h512l-4 32h20a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M24.5 44.1l-24 96A16 16 0 0 0 16 160h97.3l25.6-128H40a16 16 0 0 0-15.5 12.1zM145.9 160H272V32H171.5zM304 32v128h126.1L404.5 32zm271.5 108.1l-24-96A16 16 0 0 0 536 32h-98.9l25.6 128H560a16 16 0 0 0 15.5-19.9z","className":"fa-primary","key":2})]);
}

Dumpster.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Dumpster;

Dumpster.default = Dumpster;
